require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./seren-row-penthouses.json") })
        }
      }, "path---seren-row-penthouses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---seren-row-penthouses!./.cache/json/seren-row-penthouses.json
// module id = 890
// module chunks = 231608221292675